// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"512":"2cb40712","533":"4a9b465b","833":"faec925e","854":"29dea6b2","974":"59deef22"}[chunkId] + ".chunk.js";
};